<template>
  <StandardDialogFullScreen>
    <template #header-text>
      <TFlex>
        <div>{{element.name}}</div>
        <!-- <div class="ml-1"> - Plans</div> -->
      </TFlex>
    </template>
    <template #header-close>
      <v-btn
        icon
        @click="$router.push({
          name: 'ProjectStructureDetails',
          })"
        >
        <v-icon>keyboard_arrow_down</v-icon>
      </v-btn>
    </template>
    <template #content>
      <TFinderLayout
        :no_action_bar="true"
        :sidebar_left="true"
        :sidebar_right="show_process_structure"
        >
        <template #sidebar-left-header>
          <div>{{$t('Project.Structure.SpatialStructure.Header')}}</div>
        </template>
        <template #sidebar-left-body>
          <TFlex
          style="color: rgba(255,255,255, 0.4)"
          @click.native="
          selected_tree_element = {type: element.type, id: element.id},
          startNewLocation($event, 'create')
          "
          >
          <div
          class="project-structure-tree-marker green"
          v-if="selected_tree_element && selected_tree_element.type === element.type && selected_tree_element.id === element.id"
          />
          <v-icon
          color="rgba(255,255,255, 0.4)"
          class="ml-1"
          >
          {{getElementsIcon(element.type)}}
        </v-icon>
        <div class="ml-1">{{element.name}}</div>
      </TFlex>
      <ProjectStructureTree
      class="ml-6"
      :parent="element"
      :child_elements="getChildElements({parent_type: element.type, parent_id: element.id})"
      :selected_tree_element="selected_tree_element"
      marker_color="green"
      @closeWrapper="updateUDObject({
        url: [
        {[$event.type]: $event.id},
        ],
        update: {
          closed: !$event.closed
        }
        })"
        @treeElementClicked="
        selected_tree_element = $event,
        startNewLocation($event.evt, $event.type === 'spatialunits'?$event.id:'create')
        "
        @draggableUpdate="updateUObject({
          url: [
          {[$event.evt.item.id.split('#')[0]]: $event.evt.item.id.split('#')[1]},
          ],
          url_prefix: `/projects/${project_id}/projectstructure`,
          update: {
            order_index: ($event.evt.newIndex + ($event.evt.newIndex > $event.evt.oldIndex?1:0)) * 10 + 5
          }
          }).then(() => {
            updateTreeOrderIndex($event.parent)
          })"
          @draggableRemove="
          updateUObjectParent({
            url: [
            {[$event.evt.from.id.split('#')[0]]: parseInt($event.evt.from.id.split('#')[1])},
            {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
            {changeparent: ''}
            ],
            url_prefix: `/projects/${project_id}/projectstructure`,
            update: {
              target_type: $event.evt.to.id.split('#')[0],
              target_id: parseInt($event.evt.to.id.split('#')[1]),
            }
          }).then(() => {
            updateUObject({
              url: [
              {[$event.evt.item.id.split('#')[0]]: parseInt($event.evt.item.id.split('#')[1])},
              ],
              url_prefix: `/projects/${project_id}/projectstructure`,
              update: {
                order_index: $event.evt.newIndex * 10 + 5,
                parent: {type: $event.evt.to.id.split('#')[0], id: $event.evt.to.id.split('#')[1]}
              }
            }).then(() => {
              updateTreeOrderIndex($event.parent)
            })
          })
          "
          @draggableAdd="updateTreeOrderIndex($event.parent)"
          />
        </template>
        <template #sidebar-left-footer>
          <draggable
          :group="{name: 'spatial_elements', pull: 'clone', put: false}"
          :sort="false"
          animation="300"
          forceFallback="true"
          fallbackOnBody="true"
          :value="spatial_elements"
          @end="createUObject({
            url: [
            {[$event.to.id.split('#')[0]]: $event.to.id.split('#')[1]},
            {[$event.item.id.split('#')[0]]: ''},
            {showWithEntitiesNormalized: ''}
            ],
            url_prefix: `/projects/${project_id}/projectstructure`,
            resp_data: JSON.parse(JSON.stringify(Object.assign(spatial_elements[$event.oldIndex], {order_index: $event.newIndex * 10 + 5, parent: {type: $event.to.id.split('#')[0], id: $event.to.id.split('#')[1]}})))
          }).then((id) => {
          })"
          >
          <!-- v-if="showSpatialElement(element.type, spatial_element.type)" -->
          <template v-for="spatial_element in spatial_elements">
            <v-chip
            :key="spatial_element.name"
            :id="spatial_element.type+'#-1'"
            style="cursor: grab; height: 32px; width: 32px; margin-right: 2px; padding: 8px"
            color="rgb(30,30,30)"
            class="mr-1"
            >
            <v-icon  small>{{getElementsIcon(spatial_element.type)}}</v-icon>
          </v-chip>
        </template>
      </draggable>
        </template>
        <template #content>
          <template v-if="selected_plan.plan_url === ''">
            <v-btn
              style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%)"
              @click="$refs.uploadPlan.click()"
              >
              {{$t('Project.Structure.Plan.UploadPdf')}}
            </v-btn>
          </template>
          <template v-else>
            <TFlex
              style="
                position: absolute;
                z-index: 60;
                left: 50%;
                top: 3px;
                transform: translateX(-50%);
                align-items: center
                "
              >
              <v-btn
                v-if="performance_mode"
                small
                @click="renderPDF()"
                >
                <v-progress-circular
                  v-if="pdf_rendering"
                  indeterminate
                  size="20"
                  width="2"
                  />
                <div v-else>{{$t('Project.Structure.Plan.Rerender')}}</div>
              </v-btn>
              <v-btn
                small
                :class="`${performance_mode?'green':'grey darken-4'} ml-1`"
                @click="performance_mode = !performance_mode"
                >
                {{$t('Project.Structure.Plan.PerformanceMode')}}
              </v-btn>
              <v-btn
                small
                :class="`${wheel_zoom?'green':'grey darken-4'} ml-1`"
                @click="wheel_zoom = !wheel_zoom"
                >
                {{$t('Project.Structure.Plan.WheelZoom')}}
              </v-btn>
              <v-btn
                class="grey darken-4 ml-1"
                icon
                @click="plan_zoom-=0.3"
                >
                <v-icon>remove</v-icon>
              </v-btn>
              <v-btn
                class="grey darken-4 ml-1"
                icon
                @click="plan_zoom+=0.3"
                >
                <v-icon>add</v-icon>
              </v-btn>
              <v-btn
                :class="`${plan_measurement.active?'green':'grey darken-4'} ml-1`"
                icon
                @click="togglePlanMeasure($event, plan_measurement.active?true:false)"
                >
                <v-icon>straighten</v-icon>
              </v-btn>
              <v-btn
                v-if="plan_measurement.active"
                :class="`${plan_measurement.rectangle?'green':'grey darken-4'} ml-1`"
                icon
                @click="plan_measurement.rectangle = !plan_measurement.rectangle, togglePlanMeasure($event, false)"
                >
                <v-icon>crop_din</v-icon>
              </v-btn>
              <v-btn
                small
                :class="`${show_spatialunits?'green':'grey darken-4'} ml-1`"
                @click="
                  show_spatialunits = !show_spatialunits,
                  selected_tree_element = {type: element.type, id: element.id},
                  startNewLocation($event, 'create')
                  "
                >
                {{$t('Project.Structure.Plan.PatialUnits')}}
              </v-btn>
              <v-btn
                small
                :class="`${show_process_structure?'green':'grey darken-4'} ml-1`"
                @click="show_process_structure = !show_process_structure"
                >
                {{$t('Project.Structure.Plan.ProcessStructure')}}
              </v-btn>
              <!-- <v-btn
                small
                :class="`${ai_mode?'green':'grey darken-4'} ml-1`"
                @click="ai_mode = !ai_mode"
                >
                AI
              </v-btn> -->
            </TFlex>
          <div
            class="project-structure-plan-wrapper"
            id="plan_wrapper"
            :style="`
              position: relative;
              height: 100%;
              width: 100%;
              overflow: scroll;
              cursor: ${plan_move.move?'grabbing':'grab'};
              justify-content: center
              `"
            @mousemove="mouseMove($event), plan_move.moved = true"
            @mousedown="planMoveStart($event), plan_move.moved = false"
            @mouseup="
              ((show_spatialunits && !edit_location && !plan_move.moved)?
                (
                  hovered_spatial_unit !== -1?
                  (
                    selected_tree_element = {type: 'spatialunits', id: hovered_spatial_unit},
                    updateCanvas()
                  )
                  :
                  ''
                )
              :
              ''),
              plan_move.move = false,
              plan_move.moved = false"
            @wheel="wheel_zoom?zoomWheel($event):''"
            @keyup.esc="
              plan_measurement.active?
              togglePlanMeasure($event, plan_measurement.paths[plan_measurement.paths.length-1].points.length === 1?true:false)
              :
              show_spatialunits?endNewLocation()
              :
              ''"
            tabindex="0"
            @keyup="planWrapperKeyEvent($event)"
            @keydown="planWrapperKeyEvent($event)"
            >
            <!-- @mousedown.native="plan_reference_point.move = true, moving_point = plan_reference_point"
            @mouseup.native="plan_reference_point.move = false" -->

            <!-- scale and reference -->
            <template v-if="!plan_measurement.active && !show_spatialunits">
              <ProjectStructurePlanPoint
                :coordinates="plan_reference_point"
                :plan_zoom="plan_zoom"
                name="reference"
                :style="point_move?'cursor: none':'cursor: pointer'"
                @mouseup.native="!plan_move.moved?(
                  plan_reference_point.move = !plan_reference_point.move,
                  moving_point = plan_reference_point,
                  !plan_reference_point.move?
                  updateUDObject({
                      url: [
                        {'plans': selected_plan.id},
                      ],
                      update: {
                        reference_x: plan_reference_point.x,
                        reference_y: plan_reference_point.y,
                      }
                    }):''
                  )
                  :moving_point = plan_reference_point
                  "
                />
              <ProjectStructurePlanPoint
                v-for="(point, index) in plan_scale.points"
                :key="index"
                :coordinates="point"
                :plan_zoom="plan_zoom"
                name="scale"
                @mouseup.native="!plan_move.moved?(
                  point.move = !point.move,
                  moving_point = point,
                  !point.move?
                  (
                    updateUDObject({
                      url: [
                        {'plans': selected_plan.id},
                      ],
                      update: {
                        scale_x_1: plan_scale.points[0].x,
                        scale_y_1: plan_scale.points[0].y,
                        scale_x_2: plan_scale.points[1].x,
                        scale_y_2: plan_scale.points[1].y,
                      }
                    }),
                    updateCanvas()
                    )
                    :''
                  )
                  :
                  moving_point = point
                  "
                :style="point_move?'cursor: none':'cursor: pointer'"
                />
              <ProjectStructurePlanPoint
                :coordinates="plan_scale.values[0].point"
                :plan_zoom="plan_zoom"
                :text="plan_scale.values[0].length"
                :style="point_move?'cursor: none':''"
                input="true"
                @changeValue="
                  plan_scale.values[0].length = $event,
                  updatePixelPerLength()
                "
                />
            </template>
            <!-- plan measurement -->
            <template v-else-if="plan_measurement.active">
              <template v-for="(path, path_index) in plan_measurement.paths">
                <template v-for="(point, index) in path.points">
                  <!-- points -->
                <ProjectStructurePlanPoint
                  :key="`path${path_index}point${index}`"
                  v-if="index !== path.points.length-1 || path_index !== plan_measurement.paths.length-1 || !close_path"
                  :coordinates="point"
                  :plan_zoom="plan_zoom"
                  @mouseup.native="
                    (close_path && index === 0 && path_index === plan_measurement.paths.length-1 && !plan_move.moved)?
                    togglePlanMeasure($event, false):
                    ((plan_measurement.rectangle && path.points.length === 2)?
                    complementRectangle($event):setMeasurePoint($event))"
                  style="cursor: none"
                  />
              </template>
              <!-- length values -->
              <ProjectStructurePlanPoint
                v-for="(value, index) in path.values"
                :key="`path${path_index}value${index}`"
                :coordinates="value.point"
                :plan_zoom="plan_zoom"
                :text="value.length"
                />
                <!-- area value -->
              <ProjectStructurePlanPoint
                :key="`path${path_index}areavalue`"
                v-if="path.area"
                :coordinates="path.area_value"
                :plan_zoom="plan_zoom"
                :text="path.area_value.value"
                dimension="2"
                />
              </template>
            </template>
            <template v-else>
            <!-- localisations -->
            <template v-for="location in locations">
              <template v-if="selected_tree_element.type === 'spatialunits' && selected_tree_element.id === location.spatial_unit_id">
                  <!-- points -->
                <ProjectStructurePlanPoint
                  v-for="(point, index) in location.path.points"
                  :key="`location${location.id}_point${index}`"
                  :id="`location${location.id}_point${index}`"
                  :coordinates="point"
                  :plan_zoom="plan_zoom"
                  :style="`cursor: ${point_move?'none':'pointer'}`"
                  @mouseup.native="
                    !plan_move.moved?
                    (
                      !edit_location_point.active?
                      (
                        edit_location_point = {
                          active: true,
                          location_id: location.id,
                          point_index: index
                          },
                        moving_point = point
                      )
                      :
                      (
                      updateUDObject({
                        url: [
                          {locations: location.id},
                        ],
                        update: {
                          path: JSON.parse(JSON.stringify(location.path))
                        }
                      }),
                      edit_location_point = {
                        active: false,
                        location_id: -1,
                        point_index: -1
                        },
                      updateCanvas()
                      )
                    )
                    :''
                    "
                  tabindex="0"
                  @keyup.native="localisazionPointKeyUp($event, index)"
                  />
              </template>
            </template>
            <!-- location edit helpers -->
            <template v-if="selected_tree_element.type === 'spatialunits' && !edit_location_point.active && selected_spatialunits_location">
            <ProjectStructurePlanEdgePoint
              v-for="(point, index) in selected_spatialunits_location.path.points"
              :key="`middlepoint${index}`"
              :coordinates="{
                x: (selected_spatialunits_location.path.points[index === selected_spatialunits_location.path.points.length-1?0:(index+1)].x + selected_spatialunits_location.path.points[index].x)/2,
                y: (selected_spatialunits_location.path.points[index === selected_spatialunits_location.path.points.length-1?0:(index+1)].y + selected_spatialunits_location.path.points[index].y)/2,
                }"
              :plan_zoom="plan_zoom"
              @click.native="insertLocalisationPoint($event, index)"
              />
            </template>

            <!-- new localisation -->
            <template v-if="edit_location && !edit_location_point.active">
              <template v-for="(point, index) in active_location.path.points">
                  <!-- points -->
                <ProjectStructurePlanPoint
                  :key="`active_location_point${index}`"
                  v-if="index !== active_location.path.points.length-1 || !close_path"
                  :coordinates="point"
                  :plan_zoom="plan_zoom"
                  style="cursor: none;"
                  @mouseup.native="
                  (close_path && index === 0 && !plan_move.moved)?
                  endNewLocation():setLocalisationPoint($event)"
                  />
              </template>
            </template>
            </template>

            <!-- edge detection -->
            <template v-if="altKey_down">
            <ProjectStructurePlanEdgePoint
              v-for="(point, index) in edges"
              :key="`edge${index}`"
              :coordinates="point"
              :plan_zoom="plan_zoom"
              :style="edge_point_clicked?'z-index: 25':''"
              @mousedown.native="edgePointMouseDown(point)"
              />
            <!-- <div
              v-for="(point, index) in edges"
              :key="`edge${index}`"
              :style="`
                position: absolute;
                left: ${point.x}px;
                top: ${point.y}px;
                z-index: 50;
                height: 1px;
                width: 1px;
                background-color: red;
                `"
              /> -->
            </template>
            <canvas
              id="plan_canvas"
              :width="1000 * plan_zoom"
              :height="plan_height * plan_zoom"
              :style="`
                position: absolute;
                z-index: 20;
                `"
            />
            <!-- ${point_move?'cursor: none;':''} -->
            <!-- <pdf
            id="plan_pdf"
            ref="plan_pdf"
            :style="`width: ${1000 * plan_zoom}px`"
            :src="selected_plan.plan_url"
            /> -->
            <!-- :key="`plan_zoom${plan_zoom_key}`" -->
            <canvas
              id="plan_pdf"
              :style="`
                position: absolute;
                z-index: 10;
                width: ${1000 * plan_zoom}px;
                `"
            />
            <!-- AI Test -->
            <!-- <canvas
              id="image_download"
              v-show="false"
              :style="`
                position: absolute;
                z-index: 60;
                `"
              height="100"
              width="100"
            /> -->
            <!-- <div
              v-if="ai_mode"
              :style="
              `position: absolute;
              display: flex;
              height: ${100 / canvas_factor * plan_zoom}px;
              width: ${100 / canvas_factor * plan_zoom}px;
              z-index: 30;
              border: solid 1px black;
              transform: translate(-50%, -50%);
              left: ${moving_point.x * plan_zoom}px;
              top: ${moving_point.y * plan_zoom}px;
              `
              "
            /> -->

          </div>
          </template>
          <input
            v-show="false"
            ref="uploadPlan"
            type="file"
            accept=".pdf"
            @change="selectPlan($refs.uploadPlan.files[0])"
            >
        </template>
        <template #sidebar-right-header>
          <div>{{$t('Project.Structure.ProcessStructure.Header')}}</div>
        </template>
      </TFinderLayout>
    </template>
  </StandardDialogFullScreen>
</template>
<script>
  import store from '@/store/index';
  import { ProjectStructurePlansMixin } from '@/mixins/ProjectStructurePlans.mixin.js'
  export default {
    mixins: [
      ProjectStructurePlansMixin,
    ],
    data: () => ({
    }),
    computed: {
      project_id() {
        return parseInt(this.$route.params.project_id);
      },
      element() {
        if (this.$route.params.spatial_units_location) {
          return store.getters['UltraDev/getUDObject']({
            type: this.$route.params.spatial_units_location.plan_parent_type,
            id: this.$route.params.spatial_units_location.plan_parent_id
          })
        } else {
          return store.getters['UltraDev/getUDObject']({
            type: this.$route.params.type,
            id: this.$route.params.structure_id
          })
        }
      },
      selected_plan() {
        if (this.$route.params.plan_id !== 'create') {
          return store.getters['UltraDev/getUDObject']({
            type: 'plans',
            id: this.$route.params.plan_id
          })
        } else {
          return false;
        }
      }
    }
  }
</script>
<style>
  .project-structure-plan-wrapper:focus {
    outline: none;
  }
</style>
